import { render, staticRenderFns } from "./PsAdministrationSubscriptions.vue?vue&type=template&id=70f8ddd4&scoped=true&"
import script from "./PsAdministrationSubscriptions.vue?vue&type=script&lang=js&"
export * from "./PsAdministrationSubscriptions.vue?vue&type=script&lang=js&"
import style0 from "./PsAdministrationSubscriptions.vue?vue&type=style&index=0&id=70f8ddd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f8ddd4",
  null
  
)

export default component.exports